export default class Position {
	constructor() {
		this.positionId = null;
		this.employmentId = null;
		this.employerName = null;
		this.positionName = null;
		this.positionLocation = null;
		this.stillWork = null;
		this.positionStartDate = null;
		this.positionEndDate = null;
	}
}
